import { formatDate } from "@angular/common";
import {
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";
import { Observable } from "rxjs";
@Component({
  selector: "app-admin-retail-notify-driver",
  templateUrl: "./admin-retail-notify-driver.component.html",
  styleUrls: ["./admin-retail-notify-driver.component.css"],
})
export class AdminRetailNotifyDriverComponent implements OnInit {
  notifyform!: FormGroup;
  workorderArray: any;
  token: any;
  vehicleArray: any;
  selectedWorkOrderQty: any;
  work_order_msg: any;
  dateFormat = "yyyy-MM-dd";
  language = "en";
  total_quantity: any;
  @Input() min: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  truckTypeNumber: any = -1;
  startPage: any = 1;
  page: any = -1;
  perPage: any = 10;
  loading: boolean = false;
  truckTypeList: any;
  workOrderQnty: any;
  work_order_qty: any;
  selectCatgValue: any;
  truckCategory: any = [];
  pickupAutoComplete: any;
  dropAutoComplete: any;
  pickupLat: any;
  pickupLong: any;
  dropLat: any;
  dropLong: any;
  tripType: any = "-1";
  completeDropAddress: any;
  completePickUpAddress: any;
  searchQuery: any = -1;
  searchtripID: any = -1;
  pickup_long_name: any = "";
  pickup_short_name: any = "";
  drop_long_name: any = "";
  drop_short_name: any = "";
  pickup_postal_code: any;
  dropoff_postal_code: any;
  selectedOption: string = "";
  @ViewChild("pickUpLocationSearchField")
  pickUpLocation: ElementRef | any;
  @ViewChild("dropLocationSearchField")
  dropLocation!: ElementRef;
  cityData = [];
  selectedValue: string | null = null;
  isAllTransporters: boolean = false;
  isFormDisabled = false;
  isNotificationRadiusDisabled = false;
  isKmsDisabled = false;
  isTruckLocationDisabled = false;
  isTimerDisabled = false;
  selectedLoadedQuantity: any;
  radioButtonSelected: any;
  constructor(
    private formBuilder: FormBuilder,
    private matdialogref: MatDialogRef<AdminRetailNotifyDriverComponent>,
    private services: AdminService,
    private router: Router,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.maxDate.setDate(this.maxDate.getDate() + 0);
  }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.GetCategory();
    this.getMasterData();
    this.notifyform = this.formBuilder.group({
      trip_id: [""],
      from_city_name: [""],
      to_city_name: [""],
      trip_start: [""],
      truck_category_name: [""],
      load_type: [""],
      truck_weight: [""],
      notification_radius: [""],
      all_transporters: [""],
      truck_home_location: [""],
      timer: [""],
    });
    this.notifyform
      .get("all_transporters")
      ?.valueChanges.subscribe((value) => this.onSelectionChange(value));

    this.notifyform.patchValue({
      trip_id: this.data.trip_id,
      from_city_name: this.data.pickup_details.from_city_name,
      to_city_name: this.data.dropoff_details.to_city_name,
      trip_start: this.formatDate(this.data.trip_start),
      truck_category_name: this.data.truckCatInfo[0]?.truck_category_name,
      load_type: this.data.load_type,
      truck_weight: this.data.truckTypeInfo[0].truck_weight,
    });
    this.workOrder();
  }

  onTransporterChange(event: any) {
    this.selectedValue = event.value;
  }
  toggleSelection() {
    const currentValue = this.notifyform.get("all_transporters")?.value;
    if (currentValue === true) {
      this.notifyform.get("all_transporters")?.setValue(false);
      this.selectedValue = "false";
    } else {
      this.notifyform.get("all_transporters")?.setValue(true);
      this.selectedValue = "true";
    }
  }
  onNotificationRadiusChange(value: any) {
    if (value) {
      this.isFormDisabled = true;
      this.isTruckLocationDisabled = false;
    } else {
      this.isFormDisabled = false;
      this.isTruckLocationDisabled = false;
    }
  }
  onSelectionChange(option: string) {
    this.selectedOption = option;

    if (option === "notificationRadius") {
      this.notifyform.get("notification_radius")?.enable();
      this.notifyform.get("truck_home_location")?.disable();
      this.notifyform.get("truck_home_location")?.setValue("");
    } else if (option === "truckHomeLocations") {
      this.notifyform.get("notification_radius")?.disable();
      this.notifyform.get("notification_radius")?.setValue("");
      this.notifyform.get("truck_home_location")?.enable();
    } else if (option === "allTransporters") {
      this.notifyform.get("notification_radius")?.disable();
      this.notifyform.get("truck_home_location")?.disable();
      this.notifyform.get("notification_radius")?.setValue("");
      this.notifyform.get("truck_home_location")?.setValue("");
    }
  }
  // onSelectionChange(option: string) {
  //   this.selectedOption = option;

  //   if (option === "notificationRadius") {
  //     this.notifyform.get("notification_radius")?.enable();
  //     this.notifyform.get("truck_home_location")?.disable();
  //   } else if (option === "truckHomeLocations") {
  //     this.notifyform.get("notification_radius")?.disable();
  //     this.notifyform.get("truck_home_location")?.enable();
  //   } else if (option === "1") {
  //     this.notifyform.get("notification_radius")?.disable();
  //     this.notifyform.get("truck_home_location")?.disable();
  //   }
  // }
  onTruckHomeLocationChange(event: any) {
    if (event.value) {
      this.isFormDisabled = false;
      this.isTruckLocationDisabled = true;
    } else {
      this.isFormDisabled = false;
      this.isTruckLocationDisabled = false;
    }
  }

  formatDate(str: any) {
    const date = new Date(str);
    return String(date.toLocaleDateString());
  }

  close() {
    this.matdialogref.close();
  }

  getMasterData() {
    this.services.GetMasterList(this.token).subscribe((resp) => {
      //@ts-ignore
      //@ts-ignore
      this.cityData = [...resp.body.data.fromCityDetail];
    });
  }

  workOrder() {
    this.services
      .GetAdminTrips(
        this.token,
        this.startPage,
        this.perPage,
        this.searchQuery,
        this.searchtripID,
        this.tripType
      )
      .subscribe(
        (response: any) => {
          this.vehicleArray = response.body.data;
          this.workorderArray = response.body.data;
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  public gettruckCatg(item: any) {
    this.selectCatgValue = item.value;
    this.services.GetTypeTruck(this.selectCatgValue, this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.truckTypeList = response.body.data;
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  //  token?: any,
  //   truckTypeNumber?: any,
  //   perPage?: any,
  //   pageCount?: any

  public GetCategory() {
    this.services
      .GetCategory(
        this.token,
        this.truckTypeNumber,
        this.perPage,
        this.startPage
      )
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.truckCategory = response.body.data;
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  public formatFormDate(date: Date) {
    return formatDate(date, this.dateFormat, this.language);
  }

  selectChangeHandler(item: any) {
    this.selectedWorkOrderQty = item;
    this.work_order_msg = item.workorder_id;
    let _id = this.notifyform.value.workorder_id;
    this.services
      .selectedWorkOrder(_id, this.token)
      .subscribe((response: any) => {
        this.notifyform.patchValue({
          price_per_ton: response.body.data.price_per_ton,
          work_order_date: this.formatFormDate(response.body.data.createdAt),
        });
        this.total_quantity = response.body.data.remaining_tons;
      });
    this.notifyform.get("remaining_tons")?.patchValue(item.remaining_tons);
    this.notifyform.get("total_tons")?.patchValue(item.total_tons);
  }

  remainingQnty(event: any) {
    this.workOrderQnty = event.target.value;
    this.work_order_qty =
      this.notifyform.value.remaining_tons - this.workOrderQnty;
    if (this.work_order_qty >= 0 || this.workOrderQnty == this.work_order_qty) {
      this.notifyform.patchValue({
        remaining_tons: this.work_order_qty,
      });
    } else {
      this.notifyform.patchValue({
        remaining_tons: this.notifyform.value.remaining_tons,
      });
      this.snackBar.open(
        "Work Order Quantity Should not Exceed With Remaining Quantity",
        "Fail",
        {
          duration: 5000,
        }
      );
    }
  }

  notify() {
    if (this.notifyform.invalid) {
      this.snackBar.open("Please fill all the mandatory fields", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (this.selectedLoadedQuantity != true) {
      this.radioButtonSelected =
        this.notifyform.value.notification_radius ||
        this.notifyform.value.truck_home_location;
      if (!this.radioButtonSelected) {
        this.snackBar.open(
          "Please select one of the notification options",
          "Fail",
          {
            duration: 5000,
          }
        );
        return;
      }
    } else if (this.radioButtonSelected == "") {
      this.snackBar.open("Please enter the selected value", "fail", {
        duration: 5000,
      });
      return;
    }
    const notifyObj = {
      trip_id: this.data._id,
      trip_booking_date: formatDate(this.data.trip_start, "yyyy-MM-dd", "en"),
      truck_category: this.data.truck_category,
      load_type: this.notifyform.value.load_type,
      notification_radius:
        Number(this.notifyform.value.notification_radius) || "",
      truck_home_location: this.notifyform.value.truck_home_location || "",
      timer: Number(this.notifyform.value.timer),
      all_transporters: this.selectedLoadedQuantity || false,
    };

    if (notifyObj.timer == 0) {
      this.snackBar.open("Please enter valid timer", "Fail", {
        duration: 5000,
      });
      return;
    }

    this.services.notifyDriver(notifyObj, this.token).subscribe(
      (response: any) => {
        this.loading = true;
        if (response.status == 200) {
          this.matdialogref.close();
          this.workOrder();
          this.snackBar.open(response.body.message, "Success", {
            duration: 5000,
          });
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
    this.loading = false;
  }
  selectLoadedQty(event: any) {
    this.selectedLoadedQuantity = event === "true" || event === true;
  }
}
